<template>
  <div class="Interview_notice">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">

      <el-tab-pane label="信息发送" name="first">
        <el-button type="primary" :loading="iscontinuous" style="margin-left:14px" @click="sendfun()">按人员发送</el-button>

        <el-button type="primary" :loading="iscontinuous" style="margin-left:54px" @click="sendfun2()">按单位发送</el-button>
        <el-form style="padding:14px" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="综合查询">
            <el-input v-model="formInline.userInfo" placeholder="综合查询"></el-input>
          </el-form-item>
          <el-form-item label="单位">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="formInline.DeptID" filterable :options="options" :props="{ checkStrictly: true }" clearable ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>

        <div class="Interview_noticeleft">

          <div style="padding:20px;padding-top:0px;">
            <el-radio v-model="Type" label="0">站内信</el-radio>
            <el-radio v-model="Type" label="1">短信</el-radio>
          </div>

          <el-input style="height: 500px;" type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>

        </div>

        <div class="Interview_noticeright">
          <el-table ref="multipleTable" v-loading="load" element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange" :row-key="(row) => {return row.userID; }">
            <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
            <el-table-column prop="userID" label="学号" min-width="60px"></el-table-column>
            <el-table-column prop="deptName" label="部门" min-width="60px"></el-table-column>
            <el-table-column prop="realName" label="姓名" min-width="60px"></el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="60px"></el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :page-size="10" layout="total, prev, pager, next" :total="Counts">
          </el-pagination>
        </div>

      </el-tab-pane>

      <el-tab-pane label="往期记录" name="second">
        <el-form style="padding:14px" :inline="true" :model="formInline2" class="demo-form-inline">
          <el-form-item label="综合查询">
            <el-input v-model="formInline2.UserInfo" placeholder="学号，姓名，身份证，手机"></el-input>
          </el-form-item>
          <el-form-item label="消息内容">
            <el-input v-model="formInline2.Message" placeholder="消息内容"></el-input>
          </el-form-item>
          <el-form-item label="消息类型">
            <el-select v-model="formInline2.Type" placeholder="请选择活动区域">
              <el-option label="站内信" value="0"></el-option>
              <el-option label="短信"   value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit2">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="multipleTable" v-loading="load2" element-loading-spinner="el-icon-loading" :data="tableData2"  style="width: 100%;">
          <el-table-column prop="userID"   label="学号"   min-width="60px"></el-table-column>
          <el-table-column prop="deptName" label="部门" min-width="60px"></el-table-column>
          <el-table-column prop="realName" label="姓名"   min-width="60px"></el-table-column>
          <el-table-column prop="phone"    label="手机号" min-width="60px"></el-table-column>
          <el-table-column prop="message"  label="内容"   min-width="60px"></el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange2" :page-size="10" layout="total, prev, pager, next" :total="Counts2">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
 
    
  </div>
</template>
<script>

export default {
  data() {
    return {
      iscontinuous:false,
      Type: '0',
      textarea: '',
      Counts:0,
      Counts2:0,
      load:true,
      load2:true,
      activeName: 'first',
      options: [],
      tableData: [],
      multipleSelection: [],
      formInline: {
        userInfo: '',
        DeptID: '',
        pageIndex: '1',
        pageSize: '10',
      },
      formInline2: {
        Message: '',
        UserInfo: '',
        DeptID2: '',
        Type: '0',
        pageIndex: '1',
        pageSize: '10',
      },
    }
  },
  beforeCreate() {

  },

  methods: {
    sendfun(){
      if(this.multipleSelection.length > 0){
        if(!this.textarea){
          alert("请输入短信内容");
          return false;
        }
        this.iscontinuous = true
        this.$Http_Post('/ConsultSubscribe/SendBatchCustomizeMessage', { Message: this.textarea, Users: this.multipleSelection,Type: this.Type,DeptID:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.iscontinuous = false
            this.Global.request_successful(res.Message);
          } else {
            this.iscontinuous = false
            this.Global.request_failure(res.Message);
          }
        })
      }else{
        alert("请选择人员！")
        // if(!this.textarea){
        //   alert("请输入短信内容");
        //   return false;
        // }
        // this.$Http_Post('/ConsultSubscribe/SendBatchCustomizeMessage', { Message: this.textarea, Users: this.multipleSelection,Type: this.Type}).then((res) => {
        //   if (res.Code == 200 || res.Code == 0) {
        //     this.Global.request_successful(res.Message);
        //   } else {
        //     this.Global.request_failure(res.Message);
        //   }
        // })
      }
    },

    sendfun2(){
      if(!this.textarea){
          alert("请输入短信内容");
          return false;
      }
      if(!this.formInline.DeptID){
          alert("请选择发送单位");
          return false;
      }
      this.$Http_Post('/ConsultSubscribe/SendBatchCustomizeMessage', { Message: this.textarea, Users: [],Type: this.Type,DeptID:this.formInline.DeptID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.iscontinuous = false
            this.Global.request_successful(res.Message);
          } else {
            this.iscontinuous = false
            this.Global.request_failure(res.Message);
          }
        })
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.loads();
    },
    handleCurrentChange2(val) {
      this.formInline2.pageIndex = val;
      this.loads2();
    },
    loads(){
      this.load = true
      this.$Http_Post('/User/GetSimpleUserList', { userInfo: this.formInline.userInfo, deptID: this.formInline.DeptID,pageSize: this.formInline.pageSize,pageIndex:this.formInline.pageIndex}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load = false;
          this.tableData = res.Data;
          this.Counts = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    loads2(){
      this.load2 = true
      this.$Http_Post('/ConsultSubscribe/GetMessageHistoryList', { 
        Message: this.formInline2.Message, 
        UserInfo: this.formInline2.UserInfo,
        pageSize: this.formInline2.pageSize,
        pageIndex:this.formInline2.pageIndex,
        Type:this.formInline2.Type,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load2 = false;
          this.tableData2 = res.Data;
          this.Counts2 = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleSelectionChange(val) {
      var cjdjcd = [];
      for (var i = 0; i < val.length; i++) {
        cjdjcd.push(val[i].userID);
      }
      this.multipleSelection = cjdjcd;
    },
    handleClick(tab, event) {
      if(this.activeName == 'first'){
        this.loads();
      }else{
        this.loads2();
      }
    },
    onSubmit() {
      this.formInline.pageIndex = 1;
      this.loads();
    },
    onSubmit2() {
      this.formInline2.pageIndex = 1;
      this.loads2();
    },
    Selected_to_shut_dow(dt) {
      this.formInline.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    bumen(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i];
          break
        } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children,
          )
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...' }]
        this.$Http_Post('/DepartMent/getalldepartmentbynode', {DeptID: dt[dt.length - 1],content: '',}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break;
        }
      }
      return obj;
    },
  },
  created() {
    this.$Http_Post('/DepartMent/getalldepartmentbynode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.options = res.Data;
        //this.formInline.DeptID = res.Data[0].DeptID;
        //this.loads();
        this.load = false;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
}
</script>
<style>
.Interview_notice{height: 100%;width: 100%;background-color: #fff;}
.Interview_notice .Interview_noticeleft{width: 350px;height: 100%;float: left;}
.Interview_notice .Interview_noticeright{width: calc(100% - 370px);height: 100%;float: left;margin-left: 20px;}
.Interview_notice .el-textarea__inner{height: 500px;width: 90%;margin-left: 5%;}
</style>
